<template>
  <div>
    <section class="d-flex flex-column">
      <div class="d-flex">
        <h3>
          {{ $t('objects.video_materials') }}
        </h3>
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('content_management')"
          variant="primary"
          class="ml-auto"
          @click="$refs.newFile.$el.click()"
        >
          <feather-icon
            icon="PlusIcon"
          />
          {{ $t('objects.add_video') }}
        </b-button>
      </div>
      <hr class="w-100">
      <b-row>
        <b-col
          v-for="(video, index) in GET_OBJECT_MEDIA.video"
          :key="index"
          cols="4"
        >
          <b-card bg-variant="light">
            <b-embed
              type="iframe"
              aspect="16by9"
              :src="video.file_link"
              allowfullscreen
            />
            <p> {{ video.title }} </p>
            <div class="d-flex justify-content-around mt-1">
              <!-- <b-button
                size="sm"
                variant="link"
              >
                <feather-icon icon="PlusIcon" />Опубликовать
              </b-button>
              <b-button
                size="sm"
                variant="link"
              >
                <feather-icon
                  class="text-warning"
                  icon="EditIcon"
                />
              </b-button> -->
              <b-button
                v-if="GET_USER_PERMISSIONS.includes('content_management')"
                size="sm"
                variant="outline-danger"
                @click="deleteMedia(video.id)"
              >
                <feather-icon
                  class="text-danger"
                  icon="TrashIcon"
                />
                {{ $t('generals.delete') }}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-form-file
        ref="newFile"
        v-model="new_file"
        plain
        class="d-none"
        accept="image/*, video/*"
        :browse-text="$t('objects.select_floor_plans')"
        @input="fileChanged"
      />
    </section>
    <section class="mt-2 d-flex flex-column">
      <div class="d-flex">
        <h3>
          {{ $t('objects.youtube_links') }}
        </h3>
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('content_management')"
          v-b-modal.url-upload
          class="ml-auto"
          variant="primary"
        >
          <feather-icon
            icon="PlusIcon"
          />
          {{ $t('objects.add_youtube_link') }}
        </b-button>
      </div>
      <hr class="w-100">
      <b-row>
        <b-col
          v-for="(link, index) in GET_OBJECT_MEDIA.links"
          :key="index"
          cols="4"
        >
          <b-card bg-variant="light">
            <b-embed
              type="iframe"
              aspect="16by9"
              :src="link"
              allowfullscreen
            />
            <p> {{ link.title }} </p>
            <div class="d-flex justify-content-around mt-1">
              <!-- <b-button
                size="sm"
                variant="link"
              >
                <feather-icon icon="PlusIcon" />Опубликовать
              </b-button>
              <b-button
                size="sm"
                variant="link"
              >
                <feather-icon
                  class="text-warning"
                  icon="EditIcon"
                />
              </b-button> -->
              <b-button
                v-if="GET_USER_PERMISSIONS.includes('content_management')"
                size="sm"
                variant="outline-danger"
                @click="deleteLink(index)"
              >
                <feather-icon
                  class="text-danger"
                  icon="TrashIcon"
                />
                {{ $t('generals.delete') }}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        id="url-upload"
        :cancel-title="$t('generals.cancel')"
        :ok-title="$t('generals.save')"
        :title="$t('objects.adding_new_link')"
        @ok.prevent="saveUrl"
      >
        <validation-observer ref="linkValidation">
          <custom-validated-input
            v-model="new_url"
            :field-label="$t('objects.link_to_video')"
            validation-rules="required"
          />
        </validation-observer>
      </b-modal>
    </section>
    <section>
      <div class="d-flex">
        <h3>
          {{ $t('objects.construction_progress') }}
        </h3>
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('content_management')"
          v-b-modal.construction-progress-modal
          class="ml-auto"
          variant="primary"
        >
          <feather-icon
            icon="PlusIcon"
          />
          {{ $t('generals.add') }}
        </b-button>
      </div>
      <b-row
        v-for="progress in GET_CONSTRUCTION_PROGRESS"
        :key="progress.id"
        class="mb-3"
      >
        <b-col cols="12">
          <p class="text-center">
            {{ progress.description }}
          </p>
          <p class="text-center">
            {{ $_dateTimeFormatter(progress.date).split(',')[0] }}
          </p>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col
              v-for="(image, index) in progress.image"
              :key="index"
              cols="6"
            >
              <b-img
                thumbnail
                class="w-100"
                :src="image"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-for="(link, index) in progress.link"
          :key="index"
          md="6"
        >
          <b-row>
            <b-col cols="6">
              <b-embed
                type="iframe"
                aspect="16by9"
                :src="link"
                allowfullscreen
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
    <b-modal
      id="construction-progress-modal"
      :title="$t('objects.add_construction_progress')"
      :ok-title="$t('generals.save')"
      size="xl"
      :cancel-title="$t('generals.cancel')"
      @ok="saveProgress"
    >
      <validation-observer ref="constructionRules">
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('objects.links_in_youtube')">
              <b-form-tags
                v-model="new_construction_progress.links"
                :placeholder="$t('objects.add_links')"
                input-id="tags-basic"
                :add-button-text="$t('objects.new')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('objects.picture')+':'">
              <b-form-file
                v-model="new_construction_progress.image"
                :placeholder="$t('objects.add_files')"
                accept="image/*"
                multiple
                :browse-text="$t('objects.select')"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('objects.date')+':'">
              <validation-provider
                #default="{ errors }"
                :name="$t('objects.date')"
                rules="required"
              >
                <flat-pickr
                  v-model="new_construction_progress.date"
                  class="form-control bg-white"
                  style="max-width: 250px;"
                  :config="configdateTimePicker"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="10">
            <b-form-group :label="$t('objects.description')+':'">
              <b-form-input v-model="new_construction_progress.description" />
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BImg,
  BButton, BEmbed, BFormFile, BModal, BFormGroup, BFormTags, BFormInput,
} from 'bootstrap-vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import CustomValidatedInput from '@/components/CustomValidatedInput.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BRow,
    BCol,
    FeatherIcon,
    BCard,
    BImg,
    BButton,
    BFormFile,
    BEmbed,
    BModal,
    CustomValidatedInput,
    BFormGroup,
    BFormTags,
    flatPickr,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [formatters],
  data() {
    return {
      required,
      new_file: null,
      new_url: '',
      new_construction_progress: {
        object: this.$route.params.id,
        links: [],
        image: [],
      },
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
    }
  },
  computed: {
    ...mapGetters('objects', ['GET_OBJECT_MEDIA', 'GET_CONSTRUCTION_PROGRESS']),
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
    photos() {
      return [
        {
          id: 1,
          title: 'rasm',
          image: 'https://picsum.photos/1024/840/?image=41',
        },
      ]
    },
    videos() {
      return [
        {
          id: 1,
          url: 'http://mytube.uz/803453.embed',
        },
      ]
    },
  },
  mounted() {
    this.FETCH_ONE_OBJECT(this.$route.params.id).then(() => {
      this.updateBreadcrumb()
    })
    this.FETCH_CONSTRUCTION_PROGRESS(this.$route.params.id)
  },
  methods: {
    ...mapActions('objects', ['FETCH_ONE_OBJECT', 'EDIT_OBJECT', 'DELETE_MEDIA_FILE', 'FETCH_CONSTRUCTION_PROGRESS', 'ADD_CONSTRUCTION_PROGRESS']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    updateBreadcrumb() {
      const [first, second, third] = this.$_removeObjectConnection(this.$route.meta.breadcrumb)
      second.text = this.GET_OBJECT_MEDIA.title
      second.to = second.to.replace(':id', this.$route.params.id)
      this.UPDATE_BREADCRUMB([first, second, third])
    },
    deleteMedia(id) {
      this.DELETE_MEDIA_FILE(id).then(() => {
        this.$_successToast(this.$t('generals.deleted'))
        this.FETCH_ONE_OBJECT(this.$route.params.id)
      }).catch(() => {
        this.$_errorToast(this.$t('generals.error'))
      })
    },
    deleteLink(index) {
      const new_links = this.$_removeObjectConnection(this.GET_OBJECT_MEDIA.links)
      new_links.splice(index, 1)
      console.log(new_links)
      this.EDIT_OBJECT({ id: this.$route.params.id, links: new_links }).then(() => {
        this.$_successToast(this.$t('generals.deleted'))
        this.FETCH_ONE_OBJECT(this.$route.params.id)
      }).catch(() => {
        this.$_errorToast(this.$t('generals.error'))
      })
    },
    fileChanged() {
      if (this.new_file.type.includes('image') || this.new_file.type.includes('video')) {
        const fd = new FormData()
        fd.append('video', this.new_file)
        fd.append('id', this.$route.params.id)
        this.EDIT_OBJECT(fd).then(() => {
          this.$_successToast(this.$t('generals.added'))
          this.FETCH_ONE_OBJECT(this.$route.params.id)
        }).catch(() => {
          this.$_errorToast(this.$t('generals.error'))
        })
      } else {
        this.$_errorToast(this.$t('objects.upload_normal_file'))
      }
    },
    generateEmbedLink(url) {
      if (url.includes('watch')) {
        const [link_id] = url.split('=').reverse()
        return `https://www.youtube.com/embed/${link_id}`
      } if (url.includes('youtu.be')) {
        const [link_id] = url.split('/').reverse()
        return `https://www.youtube.com/embed/${link_id}`
      }
      return url
    },
    async saveUrl() {
      const success = await this.$refs.linkValidation.validate()
      if (!success) return
      if (this.new_url.includes('watch')) {
        const [link_id] = this.new_url.split('=').reverse()
        this.new_url = `https://www.youtube.com/embed/${link_id}`
      } else if (this.new_url.includes('youtu.be')) {
        const [link_id] = this.new_url.split('/').reverse()
        this.new_url = `https://www.youtube.com/embed/${link_id}`
      }
      const file_urls = this.GET_OBJECT_MEDIA.links
      file_urls.push(this.new_url)
      this.EDIT_OBJECT({ id: this.$route.params.id, links: file_urls }).then(() => {
        this.$_successToast(this.$t('generals.added'))
        this.FETCH_ONE_OBJECT(this.$route.params.id)
        this.new_url = ''
      }).catch(() => {
        this.$_errorToast(this.$t('generals.error'))
      })
    },
    saveProgress(bvModal) {
      bvModal.preventDefault()
      if (!this.new_construction_progress.image.length && !this.new_construction_progress.links.length) {
        this.$_errorToast('Должно быть заполнено не менее одного поля')
        return
      }
      this.$refs.constructionRules.validate().then(success => {
        if (success) {
          console.log(this.new_construction_progress)
          const fd = new FormData()
          this.new_construction_progress.links.forEach(el => {
            console.log(this.generateEmbedLink(el))
            fd.append('link', this.generateEmbedLink(el))
          })
          this.new_construction_progress.image.forEach(el => {
            fd.append('image', el)
          })
          fd.append('object', this.new_construction_progress.object)
          fd.append('date', this.new_construction_progress.date)
          fd.append('description', this.new_construction_progress.description)
          this.ADD_CONSTRUCTION_PROGRESS(fd).then(() => {
            this.$_successToast(this.$t('generals.added'))
            this.$bvModal.hide('construction-progress-modal')
            this.new_construction_progress = {
              object: this.$route.params.id,
              links: [],
              image: [],
            }
            this.FETCH_CONSTRUCTION_PROGRESS(this.$route.params.id)
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

</style>
